import { notification, message as MobileNotification } from 'antd';
import { ArgsProps } from 'antd/lib/message';
import { getAlertIcon } from '../../utils/getAlertIcon';
import { getCloseIcon } from '../../utils/getCloseIcon';
import { PlacementPosition } from '../../../enums/placementEnums';

interface INotification {
  message: string;
  duration?: number;
  description?: string;
  type: notificationType;
  closeIcon?: React.ReactNode;
  customIcon?: React.ReactNode;
  key?: string;
  placement?: PlacementPosition;
  closable?: boolean;
  onClose?: () => void;
}

type notificationType = 'success' | 'error' | 'warning' | 'info' | 'open';

// Set once a session-expiry redirect is under way so the many unrelated
// onError/catch handlers across the app can't repopulate toasts for the
// same burst of failed requests while we're navigating to login.
let isSuppressed = false;

export const suppressNotifications = () => {
  isSuppressed = true;
};

const Notification = ({ message, description, type, duration, key, placement, closable, onClose }: INotification) => {
  if (isSuppressed) return;
  if (window.innerWidth <= 768) {
    return MobileNotification[type as notificationType]({
      content: message,
      key,
      duration,
      onClose,
    } as ArgsProps);
  }
  return notification[type as notificationType]({
    key,
    message,
    description,
    icon: getAlertIcon(type),
    closeIcon: getCloseIcon(type),
    duration,
    placement,
    onClose,
    ...(closable !== undefined ? { closable } : {}),
  });
};

export const destroyNotification = (key: string) => notification.destroy(key);

export const destroyAllNotifications = () => {
  notification.destroy();
  MobileNotification.destroy();
};

export default Notification;
